import { render, staticRenderFns } from "./Ipay88ErrorPageComponent.vue?vue&type=template&id=11294c8c&"
import script from "./Ipay88ErrorPageComponent.vue?vue&type=script&lang=js&"
export * from "./Ipay88ErrorPageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports